import { lazy } from "react";
import SingleNetworkTable from "../components/NP/Network/SingleNetworkTable";

import Alarm from "../pages/NP/Alarm/Alarm";
import NPDashboard from "../pages/NP/Dashboard";
import FinanceAdmin from "../pages/NP/Finance/FinanceAdmin";
import ManageFinance from "../pages/NP/Finance/ManageFinance";
import Area from "../pages/NP/GeoInfo/Area";
import ManageArea from "../pages/NP/GeoInfo/ManageArea";
import ManageRegion from "../pages/NP/GeoInfo/ManageRegion";
import ManageTerritory from "../pages/NP/GeoInfo/ManageTerritory";
import Region from "../pages/NP/GeoInfo/Region";
import Territory from "../pages/NP/GeoInfo/Territory";
import NPManageNetwork from "../pages/NP/Network/ManageNetwork";
import NPNetwork from "../pages/NP/Network/Network";

import Payment from "../pages/NP/Payment/Payment";
import ManageRegional from "../pages/NP/RegionalAdmin/ManageRegional";
import RegionalAdmin from "../pages/NP/RegionalAdmin/RegionalAdmin";
import NPManageResource from "../pages/NP/Resource/ManageResource";
import Resource from "../pages/NP/Resource/Resource";
import ManageSupplier from "../pages/NP/Supplier/ManageSupplier";
import Profile from "../pages/NP/Supplier/Profile";
import Supplier from "../pages/NP/Supplier/Supplier";
import ViewSupplier from "../pages/NP/Supplier/ViewSupplier";
import ManageVendor from "../pages/NP/Vendor/ManageVendor";
import Vendor from "../pages/NP/Vendor/Vendor";

import KeycloakSignIn from "../pages/KeycloakSignIn";
import BatchPayment from "../pages/NP/Payment/BatchPayment";
import BatchPaymentDetails from "../pages/NP/Payment/BatchPaymentDetails";
import BatchTaskList from "../pages/NP/Payment/BatchTaskList";
import CompletedTask from "../pages/NP/Payment/CompletedTask.";
import PaymentSummary from "../pages/NP/Payment/PaymentSummary";
import POManagerList from "../pages/NP/POManager/POManagerList";
import PriceMatrixDetails from "../pages/NP/PriceMatrix/PriceMatrixDetails";
import PriceMatrixEdit from "../pages/NP/PriceMatrix/PriceMatrixEdit";
import PriceMatrixList from "../pages/NP/PriceMatrix/PriceMatrixList";
import PriceMatrixLogsList from "../pages/NP/PriceMatrix/PriceMatrixLogsList";
import ManageUser from "../pages/NP/User/ManageUser";
import User from "../pages/NP/User/User";
import VendorDetailsV2 from "../pages/NP/Vendor/VendorDetailsV2";
import SADashboard from "../pages/SA/Dashboard";
import SAArea from "../pages/SA/GeoInfo/SAArea";
import SAManageArea from "../pages/SA/GeoInfo/SAManageArea";
import SAManageRegion from "../pages/SA/GeoInfo/SAManageRegion";
import SAManageTerritory from "../pages/SA/GeoInfo/SAManageTerritory";
import SARegion from "../pages/SA/GeoInfo/SARegion";
import SATerritory from "../pages/SA/GeoInfo/SATerritory";
import SAManageNetwork from "../pages/SA/Network/SAManageNetwork";
import SANetwork from "../pages/SA/Network/SANetwork";
import SANetworkDetails from "../pages/SA/Network/SANetworkDetails";
import SAPayment from "../pages/SA/Payment/SAPayment";
import SAManageResource from "../pages/SA/Resource/SAManageResource";
import SAResource from "../pages/SA/Resource/SAResource";
import SAResourceDetails from "../pages/SA/Resource/SAResourceDetails";
import SAManageSupplier from "../pages/SA/Supplier/ManageSupplier";
import SASupplier from "../pages/SA/Supplier/Supplier";
import SupportOperator from "../pages/SA/SupportOperator/SupportOperator";
import SATask from "../pages/SA/Task/SATask";
import VendorNetwork from "../pages/Vendor/Network/Network";
import { RouteType } from "../types";
const NPLogin = lazy(() => import("../pages/NP/Login"));
const NotFound = lazy(() => import("../pages/NotFound"));
const Callback = lazy(() => import("../pages/Callback"));
const Logout = lazy(() => import("../pages/Logout"));

// auth routers
export const authRouters: RouteType[] = [
  {
    path: "/np/dashboard",
    element: NPDashboard,
    roles: ["NP"],
  },
  {
    path: "/np/networks",
    element: NPNetwork,
    roles: ["NP"],
  },
  {
    path: "/np/alarm",
    element: Alarm,
    roles: ["NP"],
  },
  {
    path: "/np/networks/add-tower",
    element: NPManageNetwork,
    roles: ["NP"],
  },
  {
    path: "/np/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["NP"],
  },
  {
    path: "/np/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["NP"],
  },

  // {
  //   path: "/np/support-agents",
  //   element: SupportAgent,
  //   roles: ["NP"],
  // },
  {
    path: "/np/payment",
    element: Payment,
    roles: ["NP"],
  },
  {
    path: "/np/po-manage",
    element: POManagerList,
    roles: ["NP"],
  },
  // Price Matrix Start
  {
    path: "/np/price-matrix",
    element: PriceMatrixList,
    roles: ["NP"],
  },
  {
    path: "/np/price-matrix-logs",
    element: PriceMatrixLogsList,
    roles: ["NP"],
  },
  {
    path: "/np/price-matrix/details/:id",
    element: PriceMatrixDetails,
    roles: ["NP"],
  },
  {
    path: "/np/price-matrix/edit/:id",
    element: PriceMatrixEdit,
    roles: ["NP"],
  },
  // GEO Information start
  {
    path: "/np/geo-info/region",
    element: Region,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/region/add-region",
    element: ManageRegion,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/region/update-region/:id",
    element: ManageRegion,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/area",
    element: Area,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/area/add-area",
    element: ManageArea,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/area/update-area/:id",
    element: ManageArea,
    roles: ["NP"],
  },

  {
    path: "/np/geo-info/territory",
    element: Territory,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/territory/add-territory",
    element: ManageTerritory,
    roles: ["NP"],
  },
  {
    path: "/np/geo-info/territory/update-territory/:id",
    element: ManageTerritory,
    roles: ["NP"],
  },
  // {
  //   path: "/np/geo-info/geo-details",
  //   element: GeoDetails,
  //   roles: ["NP"],
  // },
  // {
  //   path: "/np/geo-info/geo-details/add-geo-details",
  //   element: ManageGeoDetails,
  //   roles: ["NP"],
  // },
  // GEO information end

  {
    path: "/np/supplier",
    element: Supplier,
    roles: ["NP"],
  },
  {
    path: "/np/supplier/:id",
    element: ViewSupplier,
    roles: ["NP"],
  },
  {
    path: "/np/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["NP"],
  },
  {
    path: "/np/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["NP"],
  },
  {
    path: "/np/resource",
    element: Resource,
    roles: ["NP"],
  },
  {
    path: "/np/resource/add-resource",
    element: NPManageResource,
    roles: ["NP"],
  },
  {
    path: "/np/regional-admin",
    element: RegionalAdmin,
    roles: ["NP"],
  },
  {
    path: "/np/regional-admin/create",
    element: ManageRegional,
    roles: ["NP"],
  },
  {
    path: "/np/finance",
    element: FinanceAdmin,
    roles: ["NP"],
  },
  {
    path: "/np/finance/create",
    element: ManageFinance,
    roles: ["NP"],
  },

  {
    path: "/np/vendor",
    element: Vendor,
    roles: ["NP"],
  },

  {
    path: "/np/vendor/create",
    element: ManageVendor,
    roles: ["NP"],
  },
  {
    path: "/np/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["NP"],
  },
  {
    path: "/np/vendor/edit/:id",
    element: ManageVendor,
    roles: ["NP"],
  },

  {
    path: "/np/user",
    element: User,
    roles: ["NP"],
  },
  {
    path: "/np/user/create",
    element: ManageUser,
    roles: ["NP"],
  },

  // {
  //   path: "/np/tasks",
  //   element: Task,
  //   roles: ["NP"],
  // },

  // ====== Support Agent ======
  {
    path: "/sa/dashboard",
    element: SADashboard,
    roles: ["SA"],
  },
  {
    path: "/sa/support-operators",
    element: SupportOperator,
    roles: ["SA"],
  },
  {
    path: "/sa/networks",
    element: SANetwork,
    roles: ["SA"],
  },
  {
    path: "/sa/alarm",
    element: Alarm,
    roles: ["SA"],
  },
  {
    path: "/sa/networks/add-tower",
    element: SAManageNetwork,
    roles: ["SA"],
  },
  {
    path: "/sa/networks/update-tower/:id",
    element: SAManageNetwork,
    roles: ["SA"],
  },
  {
    path: "/sa/networks/network-details",
    element: SANetworkDetails,
    roles: ["SA"],
  },
  {
    path: "/sa/payment",
    element: SAPayment,
    roles: ["SA"],
  },

  {
    path: "/sa/geo-info/region",
    element: SARegion,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/region/add-region",
    element: SAManageRegion,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/region/update-region/:id",
    element: SAManageRegion,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/area",
    element: SAArea,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/area/add-area",
    element: SAManageArea,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/area/update-area/:id",
    element: SAManageArea,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/territory",
    element: SATerritory,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/territory/add-territory",
    element: SAManageTerritory,
    roles: ["SA"],
  },
  {
    path: "/sa/geo-info/territory/update-territory/:id",
    element: SAManageTerritory,
    roles: ["SA"],
  },
  {
    path: "/sa/supplier",
    element: SASupplier,
    roles: ["SA"],
  },
  {
    path: "/sa/supplier/:id",
    element: ViewSupplier,
    roles: ["SA"],
  },
  {
    path: "/sa/supplier/add-supplier",
    element: SAManageSupplier,
    roles: ["SA"],
  },
  {
    path: "/sa/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["SA"],
  },
  {
    path: "/sa/resource",
    element: SAResource,
    roles: ["SA"],
  },
  {
    path: "/sa/resource/add-resource",
    element: SAManageResource,
    roles: ["SA"],
  },
  {
    path: "/sa/resource/resource-details",
    element: SAResourceDetails,
    roles: ["SA"],
  },
  {
    path: "/sa/tasks",
    element: SATask,
    roles: ["SA"],
  },
  // {
  //   path: "/sa/payment",
  //   element: Payment,
  //   roles: ["SA"],
  // },

  // ====== Vendor Panel ======
  // GEO Information start
  {
    path: "/vendor/dashboard",
    element: NPDashboard,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/region",
    element: Region,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/region/add-region",
    element: ManageRegion,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/region/update-region/:id",
    element: ManageRegion,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/area",
    element: Area,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/area/add-area",
    element: ManageArea,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/area/update-area/:id",
    element: ManageArea,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/territory",
    element: Territory,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/territory/add-territory",
    element: ManageTerritory,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/geo-info/territory/update-territory/:id",
    element: ManageTerritory,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/networks",
    element: VendorNetwork,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/payment/completed-task",
    element: CompletedTask,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/payment/batch-payment",
    element: BatchPayment,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/payment/batch-payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/payment/batch-payment/task-list/:id",
    element: BatchTaskList,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/supplier",
    element: Profile,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/supplier/:id",
    element: ViewSupplier,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/resource",
    element: Resource,
    roles: ["VENDOR"],
  },
  {
    path: "/vendor/resource/add-resource",
    element: NPManageResource,
    roles: ["VENDOR"],
  },

  // ===========================
  // ====== Regional Panel ======
  // ===========================
  {
    path: "/regional/dashboard",
    element: NPDashboard,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/networks",
    element: NPNetwork,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/networks/add-tower",
    element: NPManageNetwork,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/alarm",
    element: Alarm,
    roles: ["REGIONAL"],
  },

  {
    path: "/regional/supplier",
    element: Supplier,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/payment/completed-task",
    element: CompletedTask,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/payment/batch-payment",
    element: BatchPayment,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/payment/batch-payment/payment-summary/:id",
    element: PaymentSummary,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/payment/batch-payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/supplier/:id",
    element: ViewSupplier,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/resource",
    element: Resource,
    roles: ["REGIONAL"],
  },
  {
    path: "/regional/resource/add-resource",
    element: NPManageResource,
    roles: ["REGIONAL"],
  },

  {
    path: "/regional/vendor",
    element: Vendor,
    roles: ["REGIONAL"],
  },

  {
    path: "/regional/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["REGIONAL"],
  },

  // ===========================
  // ====== ClusterOps Panel ===
  // ===========================
  {
    path: "/cluster-ops/dashboard",
    element: NPDashboard,
    roles: ["CLUSTER"],
  },
  {
    path: "/cluster-ops/payment",
    element: BatchPayment,
    roles: ["CLUSTER"],
  },
  {
    path: "/cluster-ops/payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["CLUSTER"],
  },

  {
    path: "/cluster-ops/vendor",
    element: Vendor,
    roles: ["CLUSTER"],
  },

  {
    path: "/cluster-ops/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["CLUSTER"],
  },

  // ===========================
  // ====== EnergyOps Panel ===
  // ===========================
  {
    path: "/energy-ops/dashboard",
    element: NPDashboard,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/payment",
    element: BatchPayment,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/networks",
    element: NPNetwork,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/networks/add-tower",
    element: NPManageNetwork,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/supplier",
    element: Supplier,
    roles: ["ENERGYOPS"],
  },

  {
    path: "/energy-ops/supplier/:id",
    element: ViewSupplier,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/vendor",
    element: Vendor,
    roles: ["ENERGYOPS"],
  },

  {
    path: "/energy-ops/vendor/create",
    element: ManageVendor,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["ENERGYOPS"],
  },
  {
    path: "/energy-ops/vendor/edit/:id",
    element: ManageVendor,
    roles: ["ENERGYOPS"],
  },

  // ===========================
  // ====== DirectorOps Panel ==
  // ===========================
  {
    path: "/director-ops/dashboard",
    element: NPDashboard,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/payment",
    element: BatchPayment,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/networks",
    element: NPNetwork,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/networks/add-tower",
    element: NPManageNetwork,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/supplier",
    element: Supplier,
    roles: ["DIRECTOROPS"],
  },

  {
    path: "/director-ops/supplier/:id",
    element: ViewSupplier,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/resource",
    element: Resource,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/resource/add-resource",
    element: NPManageResource,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/vendor",
    element: Vendor,
    roles: ["DIRECTOROPS"],
  },

  {
    path: "/director-ops/vendor/create",
    element: ManageVendor,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["DIRECTOROPS"],
  },
  {
    path: "/director-ops/vendor/edit/:id",
    element: ManageVendor,
    roles: ["DIRECTOROPS"],
  },

  // ===========================
  // ====== GrOps Panel ==
  // ===========================
  {
    path: "/gr-ops/dashboard",
    element: NPDashboard,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/payment",
    element: BatchPayment,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/networks",
    element: NPNetwork,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/networks/add-tower",
    element: NPManageNetwork,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/supplier",
    element: Supplier,
    roles: ["GROPS"],
  },

  {
    path: "/gr-ops/supplier/:id",
    element: ViewSupplier,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/resource",
    element: Resource,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/resource/add-resource",
    element: NPManageResource,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/vendor",
    element: Vendor,
    roles: ["GROPS"],
  },

  {
    path: "/gr-ops/vendor/create",
    element: ManageVendor,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["GROPS"],
  },
  {
    path: "/gr-ops/vendor/edit/:id",
    element: ManageVendor,
    roles: ["GROPS"],
  },

  // ===========================
  // ====== Finance Panel ======
  // ===========================

  // {
  //   path: "/finance/dashboard",
  //   element: FinanceDashboard,
  //   roles: ["FINANCE"],
  // },
  {
    path: "/finance/dashboard",
    element: NPDashboard,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/payment",
    element: BatchPayment,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/payment/payment-summary/:id",
    element: PaymentSummary,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/payment/details/:id",
    element: BatchPaymentDetails,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/networks",
    element: NPNetwork,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/networks/add-tower",
    element: NPManageNetwork,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/networks/update-tower/:id",
    element: NPManageNetwork,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/networks/single-network/:id",
    element: SingleNetworkTable,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/supplier",
    element: Supplier,
    roles: ["FINANCE"],
  },

  {
    path: "/finance/supplier/:id",
    element: ViewSupplier,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/supplier/add-supplier",
    element: ManageSupplier,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/supplier/update-supplier/:id",
    element: ManageSupplier,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/resource",
    element: Resource,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/resource/add-resource",
    element: NPManageResource,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/vendor",
    element: Vendor,
    roles: ["FINANCE"],
  },

  {
    path: "/finance/vendor/create",
    element: ManageVendor,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/vendor/details/:id",
    element: VendorDetailsV2,
    roles: ["FINANCE"],
  },
  {
    path: "/finance/vendor/edit/:id",
    element: ManageVendor,
    roles: ["FINANCE"],
  },

  // =============
  // SCM Pannel
  // =============

  {
    path: "/scm/dashboard",
    element: NPDashboard,
    roles: ["SCM"],
  },
  // Price Matrix Start
  {
    path: "/scm/price-matrix",
    element: PriceMatrixList,
    roles: ["SCM"],
  },
  {
    path: "/scm/price-matrix-logs",
    element: PriceMatrixLogsList,
    roles: ["SCM"],
  },
  {
    path: "/scm/price-matrix/details/:id",
    element: PriceMatrixDetails,
    roles: ["SCM"],
  },
  {
    path: "/scm/price-matrix/edit/:id",
    element: PriceMatrixEdit,
    roles: ["SCM"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  // {
  //   path: "/np/login",
  //   element: KeycloakSignIn,
  //   // element: NPLogin,
  // },
  // {
  //   path: "/sa/login",
  //   element: KeycloakSignIn,
  //   // element: SALogin,
  // },
  // {
  //   path: "/vendor/login",
  //   element: KeycloakSignIn,
  //   // element: VendorLogin,
  // },
  // {
  //   path: "/regional/login",
  //   element: KeycloakSignIn,
  //   // element: RegionalLogin,
  // },
  // {
  //   path: "/cluster-ops/login",
  //   element: KeycloakSignIn,
  //   // element: ClusterOpsLogin,
  // },
  // {
  //   path: "/energy-ops/login",
  //   element: KeycloakSignIn,
  //   // element: EnergyOpsLogin,
  // },
  // {
  //   path: "/director-ops/login",
  //   element: KeycloakSignIn,
  //   // element: DirectorOpsLogin,
  // },
  // {
  //   path: "/gr-ops/login",
  //   element: KeycloakSignIn,
  //   // element: GrOpsLogin,
  // },
  // {
  //   path: "/finance/login",
  //   element: KeycloakSignIn,
  //   // element: FinanceLogin,
  // },
  // {
  //   path: "/scm/login",
  //   element: KeycloakSignIn,
  //   // element: ScmLogin,
  // },
  {
    path: "/login",
    element: KeycloakSignIn,
    // element: ScmLogin,
  },
  {
    path: "/sso/callback",
    element: Callback,
  },
  {
    path: "/logout",
    element: Logout,
  },
  {
    path: "404",
    element: NotFound,
  },
  {
    path: "*",
    element: NotFound,
  },
];
